angular.module('impactx.userdialog').controller('UserMessagesCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    'ToolbarService',
    'ToastService',
    'TranslationService',
    'PartialDialogsService',
    UserMessagesCtrl
]);

function UserMessagesCtrl ($scope, dataGen, $routeParams, BackService, ToolbarService, ToastService, TranslationService,
                           PartialDialogsService) {
    var userId = $routeParams.id;
    $scope.productmenu = {menuitems: [{label: 'Placeholder', view: 'lobby'}]};
    $scope.showToolbar = false;
    $scope.allSetting = {};

    var ctrl = this;

    $scope.toggleToolbar = function () {
        $scope.showToolbar = !$scope.showToolbar;
    };
    $scope.getPageData = function () {
        dataGen.getData($scope, {id: userId}, "/user/messages/view", function () {
            defineButtons();
            angular.forEach($scope.data.messageSettings.configMessages, function(entry) {
                $scope.allSetting[entry.configView.viewType] = {value: null};
            })
        });
    };

    $scope.savePageData = function ($event, showOthers) {
        var data = $scope.data;
        var dataObj = {
            data: data
        };

        return dataGen.post($scope, dataObj, "/user/messages/save", function () {
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
            if(showOthers)
            {
                PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.USER, userId, 'usermessages', undefined, true);
            }
            else
            {
                PartialDialogsService.addDialog(PartialDialogsService.TYPE.USER, userId, 'usermessages');
                PartialDialogsService.redirectToList(PartialDialogsService.TYPE.USER, undefined);
            }
        });
    };

    ctrl.setAllSettings = function (newValue) {
        angular.forEach($scope.data.messageSettings.configMessages, function(message) {
            ctrl.setViewTypeSettings(message, newValue);
        });
    }

    ctrl.setViewTypeSettings = function (configMessage, newValue) {
        angular.forEach(configMessage.configMessages, function (type) {
            if (!type.forceMail && (newValue !== 3 || !type.notAllowedToSuppress)) {
                type.msgNotification = newValue;
            }
        });
    };

    $scope.getPageData();

    $scope.savePageDataBackToList = function ($event) {
        return $scope.savePageData($event, false)
    };

    $scope.savePageDataOtherDialogs = function ($event) {
        return $scope.savePageData($event, true)
    };

    function valueFunction() {
        return $scope.data && $scope.data.userCard && $scope.data.userCard.maxNumberOfUsersReached
            && !$scope.data.userCard.canSaveWithMaxNumberOfUsersReached;
    }

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: $scope.savePageDataBackToList,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            },
            {
                label: $scope.trns.saveAndForward,
                action: $scope.savePageDataOtherDialogs,
                type: 'validation',
                params: {
                    form: $scope.dialogData,
                    disableExpression: {
                        valueFunction: valueFunction,
                        error: $scope.data.userCard.maxNumberOfUsersReachedMessage
                    }
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}